import { OrderState } from './state';
import { orderInitialState } from './initial-state';
import { OrderActions } from './action-creators';
import * as actions from './actions';

export const orderReducer = (state: OrderState = orderInitialState, action: OrderActions): OrderState => {
  switch (action.type) {

    case actions.CREATE_ORDER: {
      return {
        ...state,
        basket: [action.order]
      };
    }

    case (actions.GET_ORDERS_SUCCESS): {

      return {
        ...state,
      };
    }

    case actions.REMOVE_ORDER: {
      return {
        ...state,
      }
    }

    case (actions.UPDATE_ORDER_SUCCESS): {
      return {
        ...state
      }
    }

    case (actions.EMPTY_BASKET): {
      return {
        ...state,
        basket: []
      }
    }

    default: {
      return { ...state };
    }
  }
}